const formatToPhone = (value = '') => {
  const input = value.replace(/\D/g, '').substring(0, 10);
  const first = input.substring(0, 3);
  const middle = input.substring(3, 6);
  const last = input.substring(6, 10);

  if (input.length > 6) { return `${first}-${middle}-${last}`; }
  if (input.length > 3) { return `${first}-${middle}`; }
  if (input.length > 0) { return `${first}`; }
  return '';
};

export const filterNumericKeyPress = (e) => {
  const keyPressed = e.key;
  if (/\D/g.test(keyPressed)) {
    e.preventDefault();
  }
};

export const generatePhoneNumberHandler = (onChange, previousValue) => (event) => {
  event.preventDefault();
  const { target } = event;
  const { name, value, selectionStart: caretPosition } = target;
  onChange({ target: { name, value: formatToPhone(value) } });
  if (value.length > (previousValue || '').length && (value.length === 8 || value.length === 4)) {
    target.setSelectionRange(caretPosition + 1, caretPosition + 1);
  } else {
    target.setSelectionRange(caretPosition, caretPosition);
  }
};
